import { useEffect, useState } from 'react'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { EVENT_TYPE_CONSULTATION, EVENT_TYPE_THERAPY_SESSION, EVENT_TYPES_ARRAY } from 'src/consumer/constants'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'
import dayjs from 'dayjs'
import ScheduledPatientsTable from './components/ScheduledPatientsTable'
import { ScheduledPatientDatePickerContainer } from './components/styledComponents'

export default function ScheduledPatients({ hideBrandFilter, hideRangeFilter, eventType }) {
  const [allTeachers, setAllTeachers] = useState()
  const [loadingMeta, setLoadingMeta] = useState()
  const [selectedClinicBrand, setSelectedClinicBrand] = useState()
  const [allClinicBrands, setAllClinicBrands] = useState()
  const [reportRange, setReportRange] = useState([
    dayjs().subtract(3, 'days'),
    dayjs().add(1, 'week'),
  ])
  const [allClinicLocations, setAllClinicLocations] = useState()

  async function getAssociatedBrands() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/clinic-brand/list',
      {},
      undefined,
      undefined,
      true,
    )
    if (resp && isCommonResponseSuccessfulV2(resp)) {
      const dat = getDataMapFromCommonResponse(resp)?.['clinic-brand']

      console.log({ dat })
      setAllClinicBrands(dat)
    }
  }

  async function getClinicLocations() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/clinic/list',
      {},
      undefined,
      undefined,
      true,
    )
    if (resp && isCommonResponseSuccessfulV2(resp)) {
      const dat = getDataMapFromCommonResponse(resp)?.['clinic']

      console.log({ dat })
      setAllClinicLocations(dat)
    }
  }

  async function getTherapistsList() {
    const resp = await getSPDataWithParams('/api/secure/cc/support/mentors/list', {
      sendAssociatedChambers: false,
      mentorEventTypes: `${EVENT_TYPE_CONSULTATION},${EVENT_TYPE_THERAPY_SESSION}`
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const mentorsList = getDataMapFromCommonResponse(resp)?.mentor
        setAllTeachers(mentorsList)
      }
    }
  }

  async function setup() {
    setLoadingMeta(true)
    await Promise.all([getTherapistsList(), getAssociatedBrands(), getClinicLocations()])
    setLoadingMeta(false)
  }

  console.log({ selectedClinicBrand })

  useEffect(() => {
    setup()
  }, [])

  console.log({ reportRange })

  return (
    <>
      <SupportHeader
        heading={`Scheduled Patients: For ${
          EVENT_TYPES_ARRAY?.find((type) => type?.id === eventType)?.altTitle
        }`}
        showBackButton
      />
      <div style={{ padding: '24px', width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
        <div className="d-flex align-items-center gap-1 flex-wrap w-100" style={{ marginBottom: '20px' }}>
          <ScheduledPatientDatePickerContainer>
            <DateRangePicker
              clearIcon={null}
              rangeDivider=" to "
              onChange={(val) => {
                const startVal = val?.[0]
                const endVal = val?.[1]
                if (endVal < startVal) {
                  return
                }
                setReportRange([dayjs(startVal), dayjs(endVal)])
              }}
              format="dd-MMM-yyyy"
              value={[reportRange?.[0].toDate(), reportRange?.[1].toDate()]}
            />
          </ScheduledPatientDatePickerContainer>
          <div style={{ maxWidth: '300px', width: '100%' }}>
            <CustomSelect
              isLoading={loadingMeta}
              options={allClinicBrands?.sort((a, b) =>
                (a?.brandName || a?.title)?.localeCompare(b?.brandName || b?.title),
              )}
              value={selectedClinicBrand}
              onChangeEvent={(e) => {
                setSelectedClinicBrand(e.target.value)
              }}
              selectType={selectTypes.object}
              placeholder="Select Clinic Brand..."
              id="brand"
              getOptionValue={(opn) => opn?.id}
              getOptionLabel={(opn) => opn?.brandName || opn?.title}
            />
          </div>
        </div>
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <ScheduledPatientsTable
            clinicBrandIds={[selectedClinicBrand?.id]}
            eventType={eventType}
            fromInDayJsFormat={reportRange?.[0]}
            toInDayJsFormat={reportRange?.[1]}
            reportFetchingApiURL={'/api/secure/cc/support/patient/get-scheduled-patients'}
            listingItemTransformer={(patientData) => {
              const brand = allClinicBrands?.find((cbr) => cbr?.id === patientData?.clinicBrandId)
              const clinicLocation = allClinicLocations?.find(
                (loc) => loc?.id === patientData?.clinicId,
              )
              const mentor = allTeachers?.find((teacher) => teacher?.id === patientData?.mentorId)
              return {
                ...patientData,
                brandData: brand,
                clinicData: clinicLocation,
                mentorDetails: mentor,
              }
            }}
          />
        </div>
      </div>
    </>
  )
}
